import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { BizChannelTypes } from '../../../Codes'
import { generateChannel } from './addChannel'

const requestReview = createAxiosThunk(
  'channelAdd/requestReview',
  (noArgs, { getState }) => {
    const {
      bizChannelType,
      unifiedUrl,
      pcUrl,
      mobileUrl,
      name,
      isUrlIndividual,
      hasAccessAccount,
      accessAccountId,
      accessAccountPassword,
      reviewDocuments,
      selectedCategoryDetail,
      kakaoTalkChannels,
      bizChannelId,
    } = getState().channel.channelAdd
    const channel = generateChannel({
      bizChannelType,
      unifiedUrl,
      pcUrl,
      mobileUrl,
      name,
      isUrlIndividual,
      hasAccessAccount,
      accessAccountId,
      accessAccountPassword,
      reviewDocuments,
      selectedCategoryDetail,
      kakaoTalkChannels,
    })
    return bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL
      ? api.channel.requestWebsiteReview(bizChannelId, channel)
      : api.channel.requestTalkChannelsReview(bizChannelId, channel)
  }
)

requestReview.reducers = builder => {
  builder.addCase(requestReview.pending, state => {
    state.apiError = null
    state.isLoading = true
  })

  builder.addCase(requestReview.fulfilled, state => {
    state.isLoading = false
  })

  builder.addCase(requestReview.rejected, (state, { payload }) => {
    state.apiError = payload
    state.isLoading = false
  })
}

export default requestReview
